import { styled } from '@mui/styles';

const UploadListStyled = styled('div')(({ theme: { palette, spacing } }: any) => ({
    '& .information': {
        padding: spacing(0, 0, 3.2),
    },
    '& .pill': {
        border: `1px solid ${palette.primary.light}`,
        padding: '3px 8px',
        margin: spacing(0, 0.6),
        boxSizing: 'border-box',
        borderRadius: '4px',
        color: `${palette.primary.light}`,
    },
}));

export default UploadListStyled;
